import React from "react";
import { ContentBookItem } from "./ContentBookItem";
import loader from "./loadingnew.svg";
import { ASSET_PATH } from "../utilities";

const ContentBookList = ({
    gettingData,
    bookData,
    maxIsbn,
    onRemoveIsbn,
    containerClass,
}) => {
    var bookListStyle = bookData.length <= 0 ? { padding: "20px" } : {};
    return (
        <div className={"side-panel-book-list-container " + containerClass}>
            <div className="side-panel-book-list">
                {gettingData && (
                    <img
                        alt="Loading..."
                        src={ASSET_PATH + loader}
                        style={bookListStyle}
                    />
                )}
                {bookData
                    .slice(-maxIsbn)
                    .reverse()
                    .map((matchingBook) => {
                        return (
                            <ContentBookItem
                                bookData={matchingBook}
                                onRemoveIsbn={onRemoveIsbn}
                            />
                        );
                    })}
                {!gettingData && bookData.length > 0 && (
                    <div className="wishlist-info-row">
                        <div className="number-items">
                            {bookData.length > maxIsbn
                                ? `1 - ${maxIsbn} of ${bookData.length} items`
                                : `${bookData.length} item${
                                      bookData.length !== 1 ? "s" : ""
                                  }`}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ContentBookList;



// WEBPACK FOOTER //
// ./src/modules/ContentBookList.js